import React from 'react';
import { Shield, Award, Leaf, CheckCircle, Radio, Droplets } from 'lucide-react';
import { certifications } from '../data/mockData';
import LightEffects from './LightEffects';

const iconMap = {
  Shield,
  Award,
  Leaf,
  CheckCircle,
  Radio,
  Droplets
};

const Certifications = () => {
  return (
    <section className="relative bg-black py-24 md:py-32">
      {/* Light Effects */}
      <LightEffects variant="lasers" />
      <LightEffects variant="strobe" />
      
      <div className="container mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-semibold text-white mb-6 tracking-tight">
            Certifications & Standards
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            Our products meet the highest international quality and safety standards
          </p>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {certifications.map((cert) => {
            const IconComponent = iconMap[cert.icon] || Shield;
            return (
              <div
                key={cert.id}
                className="group relative bg-gradient-to-br from-white/5 to-transparent border border-white/10 p-8 text-center transition-all duration-500 hover:border-blue-500/50 hover:shadow-2xl hover:shadow-blue-500/20"
                style={{ borderRadius: '0px' }}
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-600 mb-6 transition-all duration-500 group-hover:bg-blue-700">
                  <IconComponent size={36} className="text-white" />
                </div>

                {/* Certification Name */}
                <h3 className="text-xl font-semibold text-white mb-3 tracking-tight">
                  {cert.name}
                </h3>

                {/* Description */}
                <p className="text-sm text-white/60 leading-relaxed">
                  {cert.description}
                </p>

                {/* Hover Effect Line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-blue-500 transition-all duration-500 group-hover:w-full"></div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <p className="text-base text-white/50">
            All LFXPro products undergo rigorous testing and quality control in our German R&D facility
          </p>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
